import React from 'react';
import { Image, T, Tooltip } from '@colonist/ui';
import { emptyTranslation } from '@colonist/i18n';
import clsx from 'clsx';
import { getRankedDivisionImage, getRankedFullDivisionText, getRankedSubdivisionImage } from '../utils.ts';
import styles from './DivisionCell.module.scss';
export const DivisionCell = ({ division, subdivision, onClickDivisionIcon })=>{
    const divisionImage = getRankedDivisionImage(division);
    const subdivisionImage = getRankedSubdivisionImage(subdivision);
    const handleDivisionClick = (event)=>{
        event.stopPropagation();
        onClickDivisionIcon === null || onClickDivisionIcon === void 0 ? void 0 : onClickDivisionIcon(division);
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.divisionCell
    }, divisionImage && /*#__PURE__*/ React.createElement(Tooltip, {
        delay: 0,
        position: "top",
        centerText: true,
        disableOnTouch: true,
        content: /*#__PURE__*/ React.createElement(T, {
            id: getRankedFullDivisionText(division, subdivision)
        })
    }, /*#__PURE__*/ React.createElement(Image, {
        image: {
            src: divisionImage,
            alt: emptyTranslation
        },
        className: clsx(styles.divisionImage, {
            [styles.clickable]: onClickDivisionIcon != undefined
        }),
        onClick: handleDivisionClick
    })), subdivisionImage && /*#__PURE__*/ React.createElement(Image, {
        className: styles.subdivisionImage,
        image: {
            src: subdivisionImage,
            alt: emptyTranslation
        }
    }));
};
